module.exports = __webpack_public_path__ + "static/media/opportunities-footer.f58a225c.jpg";